<template>
  <v-app :style="{ 'background-color': '#f2f5f8' }">
    <v-app-bar
      app
      color="primary"
      dark
      v-if="isAuth"
      class="custom-main-app-bar"
    >
      <v-container class="d-flex align-center">
        <v-img
          src="https://cdn.ecampus-hainaut.be/logos/logo-condorcet-transparent.png"
          :max-width="$vuetify.breakpoint.smAndDown ? 138 : 158"
          contain
        ></v-img>

        <v-spacer></v-spacer>

        <v-btn
          icon
          @click="logout"
        >
          <v-icon>
            mdi-logout
          </v-icon>
        </v-btn>
      </v-container>
    </v-app-bar>

    <v-main>
      <router-view></router-view>

      <the-notification-snackbar></the-notification-snackbar>
    </v-main>

    <v-footer
      app
      class="justify-center"
      v-if="isAuth"
      color="secondary"
      dark
    >
      <the-footer></the-footer>
    </v-footer>
  </v-app>
</template>

<script>
import { mapGetters } from 'vuex';
import TheFooter from '@/components/TheFooter.vue';
import { logout } from '@/auth';
import TheNotificationSnackbar from './components/TheNotificationSnackbar.vue';

export default {
  name: 'App',

  components: {
    'the-footer': TheFooter,
    'the-notification-snackbar': TheNotificationSnackbar,
  },

  computed: {
    ...mapGetters(['isAuth']),
  },

  methods: {
    logout,
  },
};
</script>

<style>

.custom-main-app-bar > .v-toolbar__content {
  padding: 0px !important;
}

</style>
